import { RouteObject } from "react-router"
import { lazy } from "react"
import { AppLayout } from "@/router/layouts/AppLayout.tsx"
import { patient } from "@/router/patient.tsx"
import { SuspenseWrapper } from "@/router/SuspenseWrapper.tsx"

// Lazy load all components with named exports
const Dashboard = lazy(() =>
  import("@/pages/Dashboard/Dashboard.tsx").then((module) => ({
    default: module.Dashboard,
  }))
)
const OpModule = lazy(() =>
  import("@/pages/Dashboard/MainSidebar/OpModule.tsx").then((module) => ({
    default: module.OpModule,
  }))
)
const IncidentReporting = lazy(() =>
  import("@/pages/Dashboard/MainSidebar/incidentReporting.tsx").then(
    (module) => ({ default: module.IncidentReporting })
  )
)
const ErDashboard = lazy(() =>
  import("@/pages/Dashboard/ErDashboard.tsx").then((module) => ({
    default: module.ErDashboard,
  }))
)
const QualityIndicators = lazy(() =>
  import("@/pages/Dashboard/MainSidebar/QualityIndicators.tsx").then(
    (module) => ({ default: module.QualityIndicators })
  )
)
const DialysisDashboard = lazy(() =>
  import("@/pages/Dashboard/MainSidebar/DialysisDashboard.tsx").then(
    (module) => ({ default: module.DialysisDashboard })
  )
)
const Referrals = lazy(() =>
  import("@/pages/Dashboard/MainSidebar/Referrals.tsx").then((module) => ({
    default: module.Referrals,
  }))
)
const Analytics = lazy(() =>
  import("@/pages/Dashboard/MainSidebar/Analytics.tsx").then((module) => ({
    default: module.Analytics,
  }))
)
const Ams = lazy(() =>
  import("@/pages/Dashboard/MainSidebar/Ams.tsx").then((module) => ({
    default: module.Ams,
  }))
)
const CathLab = lazy(() =>
  import("@/pages/Dashboard/MainSidebar/CathLab.tsx").then((module) => ({
    default: module.CathLab,
  }))
)
const Dietetics = lazy(() =>
  import("@/pages/Dashboard/MainSidebar/Dietetics.tsx").then((module) => ({
    default: module.Dietetics,
  }))
)
const DischargeSummaryDashboard = lazy(() =>
  import("@/pages/Dashboard/MainSidebar/DischargeSummaryDashboard.tsx").then(
    (module) => ({ default: module.DischargeSummaryDashboard })
  )
)
const OperationTheatreDashboard = lazy(() =>
  import("@/pages/Dashboard/MainSidebar/OperationTheatreDashboard.tsx").then(
    (module) => ({ default: module.OperationTheatreDashboard })
  )
)
const AllPatients = lazy(() =>
  import("@/pages/Dashboard/MainSidebar/AllPatients.tsx").then((module) => ({
    default: module.AllPatients,
  }))
)
const OnCallRotas = lazy(() =>
  import("@/pages/Dashboard/MainSidebar/OnCallRotas.tsx").then((module) => ({
    default: module.OnCallRotas,
  }))
)
const NursingDashboard = lazy(() =>
  import("@/pages/Dashboard/NursingDashboard.tsx").then((module) => ({
    default: module.NursingDashboard,
  }))
)
const DmoRoster = lazy(() =>
  import("@/pages/Dashboard/MainSidebar/DmoRoster.tsx").then((module) => ({
    default: module.DmoRoster,
  }))
)
const DialysisConfig = lazy(() =>
  import("@/pages/Dashboard/MainSidebar/DialysisConfig.tsx").then((module) => ({
    default: module.DialysisConfig,
  }))
)
const Master = lazy(() =>
  import("@/pages/Dashboard/MainSidebar/Master.tsx").then((module) => ({
    default: module.Master,
  }))
)
const UserManagement = lazy(() =>
  import("@/pages/Dashboard/MainSidebar/UserManagement.tsx").then((module) => ({
    default: module.UserManagement,
  }))
)
const InvCharts = lazy(() =>
  import("@/pages/Dashboard/MainSidebar/InvCharts.tsx").then((module) => ({
    default: module.InvCharts,
  }))
)
const PolicyDocuments = lazy(() =>
  import("@/pages/Dashboard/MainSidebar/PolicyDocuments.tsx").then(
    (module) => ({ default: module.PolicyDocuments })
  )
)
const UserGuide = lazy(() =>
  import("@/pages/Dashboard/MainSidebar/UserGuide.tsx").then((module) => ({
    default: module.UserGuide,
  }))
)
const About = lazy(() =>
  import("@/pages/About.tsx").then((module) => ({ default: module.About }))
)
const Profile = lazy(() =>
  import("@/pages/Profile/Profile.tsx").then((module) => ({
    default: module.Profile,
  }))
)
const ReleaseNotes = lazy(() =>
  import("@/pages/ReleaseNotes.tsx").then((module) => ({
    default: module.ReleaseNotes,
  }))
)
const Users = lazy(() =>
  import("@/pages/Users.tsx").then((module) => ({ default: module.Users }))
)
const Units = lazy(() =>
  import("@/pages/Units.tsx").then((module) => ({ default: module.Units }))
)

export const app: RouteObject = {
  Component: AppLayout,
  children: [
    {
      index: true,
      element: (
        <SuspenseWrapper>
          <Dashboard />
        </SuspenseWrapper>
      ),
    },
    patient,
    {
      path: "opModule",
      element: (
        <SuspenseWrapper>
          <OpModule />
        </SuspenseWrapper>
      ),
    },
    {
      path: "incidentReporting",
      element: (
        <SuspenseWrapper>
          <IncidentReporting />
        </SuspenseWrapper>
      ),
    },
    {
      path: "erDashboard",
      element: (
        <SuspenseWrapper>
          <ErDashboard />
        </SuspenseWrapper>
      ),
    },
    {
      path: "qualityIndicators",
      element: (
        <SuspenseWrapper>
          <QualityIndicators />
        </SuspenseWrapper>
      ),
    },
    {
      path: "dialysisDashboard",
      element: (
        <SuspenseWrapper>
          <DialysisDashboard />
        </SuspenseWrapper>
      ),
    },
    {
      path: "referrals",
      element: (
        <SuspenseWrapper>
          <Referrals />
        </SuspenseWrapper>
      ),
    },
    {
      path: "analytics",
      element: (
        <SuspenseWrapper>
          <Analytics />
        </SuspenseWrapper>
      ),
    },
    {
      path: "ams",
      element: (
        <SuspenseWrapper>
          <Ams />
        </SuspenseWrapper>
      ),
    },
    {
      path: "cathlab",
      element: (
        <SuspenseWrapper>
          <CathLab />
        </SuspenseWrapper>
      ),
    },
    {
      path: "dietetics",
      element: (
        <SuspenseWrapper>
          <Dietetics />
        </SuspenseWrapper>
      ),
    },
    {
      path: "dischargeSummaryDashboard",
      element: (
        <SuspenseWrapper>
          <DischargeSummaryDashboard />
        </SuspenseWrapper>
      ),
    },
    {
      path: "operationTheatreDashboard",
      element: (
        <SuspenseWrapper>
          <OperationTheatreDashboard />
        </SuspenseWrapper>
      ),
    },
    {
      path: "allPatients",
      element: (
        <SuspenseWrapper>
          <AllPatients />
        </SuspenseWrapper>
      ),
    },
    {
      path: "onCallRotas",
      element: (
        <SuspenseWrapper>
          <OnCallRotas />
        </SuspenseWrapper>
      ),
    },
    {
      path: "nursingDashboard",
      element: (
        <SuspenseWrapper>
          <NursingDashboard />
        </SuspenseWrapper>
      ),
    },
    {
      path: "dmoRoster",
      element: (
        <SuspenseWrapper>
          <DmoRoster />
        </SuspenseWrapper>
      ),
    },
    {
      path: "dialysisConfig",
      element: (
        <SuspenseWrapper>
          <DialysisConfig />
        </SuspenseWrapper>
      ),
    },
    {
      path: "master",
      element: (
        <SuspenseWrapper>
          <Master />
        </SuspenseWrapper>
      ),
    },
    {
      path: "userManagement",
      element: (
        <SuspenseWrapper>
          <UserManagement />
        </SuspenseWrapper>
      ),
    },
    {
      path: "invCharts",
      element: (
        <SuspenseWrapper>
          <InvCharts />
        </SuspenseWrapper>
      ),
    },
    {
      path: "policyDocuments",
      element: (
        <SuspenseWrapper>
          <PolicyDocuments />
        </SuspenseWrapper>
      ),
    },
    {
      path: "userGuide",
      element: (
        <SuspenseWrapper>
          <UserGuide />
        </SuspenseWrapper>
      ),
    },
    {
      path: "dashboard",
      element: (
        <SuspenseWrapper>
          <Dashboard />
        </SuspenseWrapper>
      ),
    },
    {
      path: "about",
      element: (
        <SuspenseWrapper>
          <About />
        </SuspenseWrapper>
      ),
    },
    {
      path: "profile",
      element: (
        <SuspenseWrapper>
          <Profile />
        </SuspenseWrapper>
      ),
    },
    {
      path: "releaseNotes",
      element: (
        <SuspenseWrapper>
          <ReleaseNotes />
        </SuspenseWrapper>
      ),
    },
    {
      path: "users",
      element: (
        <SuspenseWrapper>
          <Users />
        </SuspenseWrapper>
      ),
    },
    {
      path: "units",
      element: (
        <SuspenseWrapper>
          <Units />
        </SuspenseWrapper>
      ),
    },
  ],
}
